export enum EnvironmentVariable {
  CCS_API_URL = "CCS_API_URL",
  TELEMETRY_ENV = "TELEMETRY_ENV",
  CRS_API_URL = "CRS_API_URL",
  CPS_API_URL = "CPS_API_URL",
  GCS_API_URL = "GCS_API_URL",
  PUBLIC_PATH = "PUBLIC_PATH",
  MFE_BUILD_ID = "MFE_BUILD_ID",
  ENVIRONMENT = "ENVIRONMENT",
  MIXPANEL_TOKEN = "MIXPANEL_TOKEN",
}

export const SERVER_ENV_VARS_WINDOW_KEY = "SERVER_ENV_VARS_WINDOW_KEY"
